import { Entity, EntityId, Location } from 'entities-next/common'
import { Stages } from 'entities-next/search-engine/stages'

export type ScoutingCampaignCriteria = Entity & {
  organizationHeadquarters?: OrganizationHeadquarters
  negativeOrganizationHeadquarters?: NegativeOrganizationHeadquarters
  organizationFoundedAt?: OrganizationFoundedAt
  organizationStages?: OrganizationStages
}

export type CreateScoutingCampaignCriteriaDto = {
  organizationHeadquarters?: Pick<OrganizationHeadquarters, 'locations'>
  negativeOrganizationHeadquarters?: Pick<NegativeOrganizationHeadquarters, 'locations'>
  organizationFoundedAt?: Pick<OrganizationFoundedAt, 'minimumYear' | 'maximumYear'>
  organizationStages?: Pick<OrganizationStages, 'stages'>
}

export type ScoutingCampaignCriteriaDto = {
  organizationHeadquarters?: OrganizationHeadquarters
  negativeOrganizationHeadquarters?: NegativeOrganizationHeadquarters
  organizationFoundedAt?: OrganizationFoundedAt
  organizationStages?: OrganizationStages
}

export type Criteria = {
  scoutingCampaignId: EntityId
} & Entity

export type OrganizationStages = Criteria & {
  stages: Stages[]
}
export type OrganizationFoundedAt = Criteria & {
  minimumYear: number
  maximumYear: number
}
export type OrganizationHeadquarters = Criteria & {
  locations: Location[]
}
export type NegativeOrganizationHeadquarters = Criteria & {
  locations: Location[]
}

export type OptionalDateRangeCheckData = {
  minimumYear?: number | null
  maximumYear?: number | null
}

export type OptionalDateRange = {
  minimumYear?: Date
  maximumYear?: Date
}

export function optionalDateRangeCheckDataToOptionalDateRange({
  minimumYear,
  maximumYear,
}: OptionalDateRangeCheckData): OptionalDateRange {
  return {
    minimumYear: minimumYear ? new Date(Date.UTC(minimumYear, 1)) : undefined,
    maximumYear: maximumYear ? new Date(Date.UTC(maximumYear, 1)) : undefined,
  }
}

export const SCOUTING_CAMPAIGN_CRITERIA_CACHE_STORE_ID = 'scouting-campaign-criteria'
